import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import moment from 'moment'
import { Typography } from '@material-ui/core'

import LineChartView from '../charts/LineChartView'
import TimeseriesDataTableView from './TimeseriesDataTableView'
import PageTitle from '../controls/PageTitle'
import { timeseriesConfig } from '../../utils/TimeseriesConfig'
import * as TimeseriesActionCreators from '../../actions/timeseries'
import * as EventActionCreators from '../../actions/event'

class TimeseriesChartContainer extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    timeseriesId: PropTypes.number.isRequired,
    from: PropTypes.instanceOf(moment).isRequired,
    to: PropTypes.instanceOf(moment).isRequired,
    timeseries: PropTypes.object.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
    events: PropTypes.object.isRequired,
    eventActions: PropTypes.object.isRequired,
  }

  static styles = () => ({
    centered: {
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  })

  static mapStateToProps(state) {
    return {
      timeseries: state.timeseries,
      events: state.events,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      eventActions: bindActionCreators(EventActionCreators, dispatch),
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.fetchData()
  }

  componentDidUpdate(prevProps) {
    if (this.props.timeseriesId !== prevProps.timeseriesId
      || this.props.from.unix() !== prevProps.from.unix()
      || this.props.to.unix() !== prevProps.to.unix()) {
      this.fetchData()
    }
  }

  fetchData = () => {
    const {
      timeseriesId,
      from,
      to,
      timeseriesActions,
      eventActions,
    } = this.props

    timeseriesActions.fetchTimeseries(timeseriesId)
    eventActions.listEvents(timeseriesId, from, to)
  }

  timeseries(timeseries = this.props.timeseries) {
    return timeseries[this.props.timeseriesId]
  }

  events() {
    return this.props.events[this.props.timeseriesId] || []
  }

  title() {
    const { from, to } = this.props
    return `${this.timeseries().title} from ${from.format('LLL')} to ${to.format('LLL')}`
  }

  render() {
    const {
      classes, from, to,
    } = this.props
    const events = this.events()
    const tsConfig = timeseriesConfig(this.timeseries().name)

    const data = []
    const dataMin = []
    const dataMax = []
    for (let x = 0; x < events.length; x += 1) {
      data.push({
        x: moment(events[x].timestamp),
        y: events[x].avg,
      })
      dataMin.push({
        x: moment(events[x].timestamp),
        y: events[x].min,
      })
      dataMax.push({
        x: moment(events[x].timestamp),
        y: events[x].max,
      })
    }

    if (data.length > 0) {
      return (
        <>
          <PageTitle title={this.title()} />
          <LineChartView
            data={data}
            dataMin={dataMin}
            dataMax={dataMax}
            label={this.timeseries().title}
            timeMin={from}
            timeMax={to}
            formatter={(v) => tsConfig.format(v, tsConfig.convert)}
            {...tsConfig.chart}
          />
          <TimeseriesDataTableView
            data={events}
            title="Detailed data"
            valueFormatter={(v) => tsConfig.format(v, tsConfig.convert)}
          />
        </>
      )
    }
    return (
      <div className={classes.centered}>
        <Typography variant="h2">Data Not Available</Typography>
      </div>
    )
  }
}

export default connect(
  TimeseriesChartContainer.mapStateToProps,
  TimeseriesChartContainer.mapDispatchToProps,
)(withStyles(TimeseriesChartContainer.styles)(TimeseriesChartContainer))
